export const LANG={
    PLEASE_ADD_VALID_EMAIL:"Please add a valid email",
    EMAIL_IS_REQUIRED: "Email is required",
    PASSWORD_IS_REQUIRED: "Password is required",
    PASSWORD: "Password",
    REMEMBER_PASSWORD:"Remember password",
    FORGOT_PASSWORD:"Forgot password",
    PASSWORD_MIN_LENGTH: "Password should be minimum 8 characters",
    PASSWORD_UPPERCASE: "One uppercase is required",
    PASSWORD_LOWERCASE: "One lowercase is required",
    PASSWORD_NUMBER: "One number is required",
    PASSWORD_SYMBOL: "One special character is required",
    PASSWORDS_MUST_MATCH: "Confirm password should match with new password",
    LOG_IN:"Log in",
    LOGIN_SUCCESSFULLY:"Login successful",
    UNEXPECTED_ERROR: "Something went wrong, please try again",
    BACK:"Back",
    JOIN: "Connect",
    SELECT:"Choose",
    LAST_NAME:"Last name",
    STREET:"Street",
    HOUSE_NO:"House number",
    ZIP_CODE:"ZIP code",
    CITY:"City",
    BIRTHDAY:"Birthday",
    BIRTHPLACE_CITY:"Place of birth",
    BIRTHPLACE_COUNTRY:"Country of birth",
    NATIONALITY:"Nationality",
    PHONE:"Telephone",
    FIRSTNAME_PARENTS:"First name (guardian/parent)",
    LASTNAME_PARENTS:"Last name (guardian/parent)",
    EMAIL_PARENTS:"Email (guardian/parent)",
    PHONE_PARENTS:"Telephone (guardian/parent)",
    BANK_NAME:"Name of the credit institution",
    IBAN_BANK_ACCOUNT:"IBAN account number",
    BIC_BANK_CODE:"BIC",
    ACCOUNT_HOLDER:"Name of account holder",
    SIGN_IN:"Sign In",
    PLEASE_CHOOSE:"Please select",
    INDIVIDUAL_YOUTH_MEMBERSHIP:"Individual youth membership",
    FAMILY_PLAN:"Family plan", 
    SPECIAL_PLAN:"Special plans",
    BIRTH_CERTIFICATE:"Copy of birth certificate",
    RESIDENCE_CERTIFICATION:"Proof of residence in the Federal Republic of Germany (confirmation from the registration authority)",
    PLAYER_PARENTS_DECLARATION:"Additional form to_players_parents can be found in the download area at www.hfv-online.de",
    COPY_OF_PASSPORT:"Copy of identity card / passport / identification document (residence permit / permit / permit)",
    APPLICATION_ATTACHMENT_ARGETINA:"The completed form can be found in the download area at www.hfv-online.de",
    APPLICATION_ATTACHMENT_ISTUPNICA:"Deregistration from the club (Istupnica)",
    APPLICATION_ATTACHMENT_BRISOVNICA:"Confirmation of deregistration from the responsible regional association (Brisovnica)",
    DASHBAORD:"Dashboard",
    EVENTS:"Events",
    PROFILE:"Profile",
    ACCOUNT_SETTING:"Account Setting",
    CHANGE_PASSWORD:"Change password",
    SUBSCRIPTION:"Subscription",
    SUBSCRIPTION_UPDATED_SUCCESSFULLY:"Subscription updated successfully",
    HELP_AND_SUPPORT:"Help and support",
    EDIT_ACCOUNT_DETAILS:"Edit account details",
    PERSONAL_INFORMATION:"Personal information",
    ADDRESS:"Address",
    BANK_DETAIL:"Bank details",
    DOCUMENTS:"Documents",
    UPDATE:"Update",
    PASSWORD_AND_SECURITY:"Password and security",
    UPDATE_YOUR_PASSWORD:"Update your password",
    ENTER_OLD_PASSWORD: "Enter the old password",
    ENTER_NEW_PASSWORD:"Enter a new password",
    ENTER_CONFIRM_PASSWORD: "Enter the verification password",
    PASSWORD_CHANGED_SUCCESSFULLY:"Password changed successfully",
    LOGOUT:"Log out",
    ENTER_REGISTERED_EMAIL:"Enter the registered email address.",
    EMAIL_NOT_FOUND:"Email not found. Please check and try again.",
    SUBMIT:"Submit",
    INVALID_EMAIL_ADDRESS:"Invalid email address",
    OTP_EXPIRED:"Wait for admin approval",
    OTP_SEND: "OTP send successfully",
    ACCOUNT_VERIFICATION:"Account verification",
    INVALID_LINK:"Invalid link",
    ACCOUNT_VERIFIED_SUCCESSFULLY:"Account successfully verified",
    LINK_EXPIRED: "Link expired",
    USER_NOT_FOUND: "User not found",
    ENTER_EMAIL_ADDRESS:"Enter the email",
    CONFIRM_PASSWORD_IS_REQUIRED: "Confirm password is required",
    FIELD_IS_REQUIRED: "Field is Required",
    FIRSTNAME_IS_REQUIRED: "First name is required",
    LASTNAME_IS_REQUIRED: "Last name is required",
    MAXIMUM_LIMIT_HUNDRED_CHAR:"The maximum restriction is 13 characters",
    MINIMUM_LIMIT_PHONE_CHAR:"The minimum restriction is 10 characters",
    MAXIMUM_LIMIT_PHONE_CHAR:"The maximum restriction is 12 characters",
    MEMBER_EMAIL:"Member's email",
    NAME:"Name",
    SIBLING_DETAILS:"Sibling details",
    INVALID_MEMBER_ID: "Invalid member email",
    MEMBER_ID:"Member ID",
    JOINED:"Joined",
    SEASON:"Season",
    CONTACT:"Contact",
    FRIEND:"Friend",
    OLD_PASSWORD_IS_REQUIRED:"Old password is required",
    NEW_PASSWORD_IS_REQUIRED:"New password is required",
    LOCATION:"Location",
    ADD_LOCATION:"Add location",


    ACCEPT:"Akzeptieren",
    DECLINE:"Ablehnen",
    SEARCH_FRIENDS:"Suche Freunde",
    VIEW_ONLY:"Nur anzeigen",
    SELECT_THE_ROLE_TO_CONTINUE:"Wählen Sie die Rolle aus, um fortzufahren",
    MEMBER:"Mitglied",
    TRAINER:"Trainer",
    SPONSOR:"Sponsor",
    TASK:"Aufgabe",
    MY_TEAM:"Mein Team",
    TOTAL_TEAM_MEMBER: "Gesamtes Teammitglied",
    ALL_MEMBERS:"Alle Mitglieder",
    VIEW_DETAILS:"Details anzeigen",
    TEAM:"Team",
    CREATE_NEW_TEAM:"Neues Team erstellen",
    ENTER_TEAM_NAME:"Geben Sie den Teamnamen ein",
    SELECT_MEMBER:"Wählen Sie Mitglied aus",
    SEARCH_MEMBER:"Mitglieder suchen",
    CHOOSE_SELECTED_MEMBER:"Wählen Sie das ausgewählte Mitglied aus",
    SELECTED_MEMBER:"Ausgewähltes Mitglied",
    CREATE_TEAM:"Team erstellen",
    TEAM_CREATED_SUCCESSFULLY:"Team erfolgreich erstellt.",
    EDIT_MEMBER:"Mitglied bearbeiten",
    UPDATED_SUCCESSFULLY:"Erfolgreich aktualisiert",
    CREATE_NEW_EVENT:"Neue Veranstaltung erstellen",
    NEW_EVENT:"Neue Veranstaltung",
    EVENT_DETAILS:"Veranstaltungsdetails",
    ASSIGNED_TRAINER:"Zugewiesener Trainer",
    BLOOD_GROUP:"Blutgruppe",
    PROFILE_UPDATED_SUCCESSFULLY:"Profil erfolgreich aktualisiert.",
    NO_FRIENDS_AVAILABLE:"Keine Freunde verfügbar",
    DESCRIPTION:"Beschreibung",
    MEMBERS_DETAIL:"Mitgliederdetails",
    ALREADY_SELECTED_IN_TEAM_B:"Bereits in Team B ausgewählt",
    ALREADY_SELECTED_IN_TEAM_A:"Bereits in Team A ausgewählt",
    EVENT_TYPE:"Ereignistyp",
    EVENT_DURATION:"Veranstaltungsdauer",
    ROOM_NAME:"Raumname",
    TIME:"Zeit",
    TIME_DURATION:"Zeitdauer",
    EVENT_DESCRIPTION:"Beschreibung der Veranstaltung",
    MAXIMUM_PARTICIPANTS:"Maximale Teilnehmerzahl",
    SELECT_MEMBERS_TEAM_A:"Wählen Sie Mitgliedsteam A aus",
    SELECT_MEMBERS_TEAM_B:"Wählen Sie Mitgliedsteam B aus",
    TEAM_AND_PARTICIPANTS_TYPE:"Teams/Einzelteilnehmer",
    EVENT:"Ereignis",
    PARTICIPANTS:"Teilnehmer",
    EVENT_NOT_FOUNDS:"Veranstaltungen nicht gefunden",
    EVENT_REQUEST_ACCEPTED_SUCCESSFULLY:"Ereignisanfrage erfolgreich angenommen",
    EVENT_REQUEST_REJECTED_SUCCESSFULLY:"Ereignisanfrage erfolgreich abgelehnt",
    ALERTS:"Alarm",
    EVENT_REQUEST:"Alarm",
    GROUND_NAME:"Bodenname",
    DURATION:"Dauer",
    DATE:"Datum",
    ACTION:"Aktion",
    DIGITAL_CARD:"Digital Card",
    AGE:"Alter",
    YEARS:"Jahre",
    MEMBERSHIP_EXPIRE:"Mitgliedschaft läuft aus",
    APPROVED:"Genehmigt!",
    UNDER_REVIEW:"Wird überprüft",
    NOTIFICATIONS:"Benachrichtigungen",
    NO_DATA:"Keine Daten",
    ongoingTask: "Laufende Aufgabe",
    task_name:"Aufgabenname",
    assign_date:"Datum zuweisen",
    description:"Beschreibung",
    status:"Status",
    comment:"Kommentare/Feedback",
    deadline:"Frist",
    action:"Aktion",
    details:"Details",
    no_ongoing_task_available:"Keine laufenden Aufgaben verfügbar",
    completed_task:"Abgeschlossene Aufgabe",
    no_completed_tasks_available:"Keine abgeschlossenen Aufgaben verfügbar",
    inprogress:"Im Gange",
    complete: "Vollständig",
    REQUEST_SENDED:"Anfrage gesendet",
    MEMBERS_IS_REQUIRED:"Mitglieder sind erforderlich.",
    TASK_DETAILS:"Aufgabendetails",
    EDIT_EVENT_DETAILS:"Bearbeiten Sie die Veranstaltungsdetails",
    EDIT:"Bearbeiten",
    CANCEL:"Stornieren",
    TASK_STATUS:"Aufgabenstatus",
    DEADLINE:"Frist",
    COMMENTS:"Kommentare",
    ADD_COMMENT:"Kommentar hinzufügen",
    INVALID_DOCUMENT_TYPE:"Ungültiger Dokumenttyp",
    PENDING:"Ausstehend",
    CLOSE:"Schließen",
    NO_FRIEND_REQUESTS:"Keine Freundschaftsanfragen",
    ACTIVE_SPONSORSHIPS:"Aktive Patenschaften",
    PAST_SPONSORSHIPS: "Frühere Sponsorings",
    COMPANY_DETAILS:"Firmendetails",
    COMPANY_NAME:"Firmenname",
    WEBSITE_URL:"Website-URL",
    COMPANY_LOGO:"Firmenlogo",
    OFFERINGS:"",
    COMPANY_DESCRIPTION:"Firmennummer",
    COMPANY_EMAIL:"Firmenemail",
    COMPANY_PHONE:"Firmentelefon",
    CREATE_FORUM:"Erstellen Sie einen Beitrag",
    TITLE:"Titel",
    ADD_COVER:"Abdeckung hinzufügen",
    ADD_IMAGE:"Bild hinzufügen",
    DELETE: "Löschen",
    FORUM:"Forum",
    SAVE: "Speichern",
    DELETED_SUCCESSFULLY:"Erfolgreich gelöscht",
    MESSAGE:"Nachricht",
    COMMENT:"Kommentar",
    ARE_YOU_SURE_WANT_TO_DELETE:"Möchten Sie es wirklich löschen?",
    ARE_YOU_SURE_WANT_TO_BOOK:"Êtes-vous sûr de vouloir réserver?",
    UPDATE_TEAM_DETAIL:"Teamdetails aktualisieren",
    TEAM_NAME:"Teamname",
    AUTHOR:"Autor",
    MAXIMUM_FILE_SIZE_IS_TEN_MB:"Die maximale Dateigröße beträgt 10 MB",
    SHOW_MORE:"Mehr anzeigen",
    VIEW_ALL:"Alle anzeigen",
    TRAINING:"Ausbildung",
    PRACTICE:"Üben",
    BOOKING: "RÉSERVATION",
    BOOK_SLOT: "Emplacement pour livre",
    AVAILABLE_SLOTS:"gEmplacements disponibles",
    NEW_SLOTS_AVAILABLE:"Nouveaux créneaux ajoutés",
    EMAIL:"E-MAIL",
    UPCOMING_EVENTS:"Kommende Veranstaltungen",
    EMPLOYMENT_DURATION:"Beschäftigungsdauer",
    LOADING:"Laden",
    SUBSCRIBE:"Abonnieren",
    SUBSCRIBE_EMAIL_SUCCESSFULLY:"E-Mail erfolgreich abonnieren"
}
